export const FETCH_START = 'FETCH_START';
export const FETCH_SUCCESS = 'FETCH_SUCCESS';
export const FETCH_ERROR = 'FETCH_ERROR';
export const FETCH_RETRY = 'FETCH_RETRY';
export const STOP_POLLING = 'STOP_POLLING';
export const START_POLLING = 'START_POLLING';
export const RESET = 'RESET';

export const DEFAULT_POLLING_INTERVAL = 3000;
export const DEFAULT_MAX_RETRIES = 10;
